import PrincipalEditor from './principal-editor';

export default PrincipalEditor;